import { render, staticRenderFns } from "./couponModel.vue?vue&type=template&id=510e5b56&scoped=true&"
import script from "./couponModel.vue?vue&type=script&lang=ts&"
export * from "./couponModel.vue?vue&type=script&lang=ts&"
import style0 from "./couponModel.vue?vue&type=style&index=0&id=510e5b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e5b56",
  null
  
)

component.options.__file = "couponModel.vue"
export default component.exports